<template>
    <div class="gift_form_root">
        <div class="gift_form_description">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                <path style="fill:#ADEBFF;" d="M304.489,413.234c-3.477-3.508-9.139-3.534-12.647-0.058c-0.32,0.316-29.788,29.518-55.19,54.879
                    l6.323,18.966c26.517-26.517,61.11-60.797,61.457-61.14C307.939,422.406,307.965,416.743,304.489,413.234z"/>
                <path style="fill:#51E9D3;" d="M304.489,372.99c-3.477-3.508-9.139-3.534-12.647-0.058c-0.32,0.316-29.788,29.518-55.191,54.88
                    l6.324,18.965c26.517-26.517,61.11-60.797,61.457-61.14C307.939,382.161,307.965,376.499,304.489,372.99z"/>
                <path style="fill:#E0F4B4;" d="M322.135,85.486V99.65l-85.486,119.023L203.112,93.158L236.649,0
                    C283.869,0,322.135,38.277,322.135,85.486z"/>
                <path style="fill:#51E9D3;" d="M189.865,46.784v327.3c0,25.846,15.483,35.069,46.784,66.37V0
                    C210.814,0,189.865,20.95,189.865,46.784z"/>
                <polygon style="fill:#51A978;" points="322.135,99.65 322.135,212.838 236.649,331.861 236.649,185.136 "/>
                <path style="fill:#3AC099;" d="M322.135,212.838v66.113c0,47.209-28.283,64.056-85.486,121.259V298.324L322.135,212.838z"/>
                <path style="fill:#80086E;" d="M236.65,512c-4.939,0-8.943-4.004-8.943-8.943V33.537c0-4.939,4.004-8.943,8.943-8.943
                    c4.939,0,8.943,4.004,8.943,8.943v469.52C245.593,507.996,241.59,512,236.65,512z"/>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
            </svg>

            <h1 v-if="sendGiftSucceeded === null">イーサリアムでお祝いを送れます</h1>
            <h1 v-else-if="sendGiftSucceeded === false">送信に失敗しました</h1>
            <div v-if="sendGiftSucceeded === null">
                <p>
                    応援している人、大切な人にメッセージ付きでお祝いを送りましょう。
                </p>
                <p>
                    お祝いを送るごとにサービス運営のため0.005 ETHを頂きます。
                </p>
            </div>
            <div v-else-if="sendGiftSucceeded === false">
                <p>
                    ブラウザのバージョンが古いか、Metamaskのウォレットに十分なEthereumが無いかもしれません。
                </p>
            </div>
        </div>

        <at-card class="form_card eth_gift_card">
            <h4 slot="title">
                <i class="icon icon-feather"></i>
                お祝イーサーを送る
            </h4>
            <div>
                <at-input v-model="senderAddress" placeholder="あなたのEthereumアドレス" class="input_sender_address"></at-input>
                <at-input v-model="receiverAddress" placeholder="相手のEthereumアドレス" class="input_receiver_address"></at-input>
                <div class="input_ether">
                    <div class="at-input-number">
                        <div class="at-input-number__input">
                            <input type="number"
                                   v-model="etherPrice"
                                   class="at-input-number__original"
                            />
                        </div>
                    </div>
                    <div class="input_ether_unit">ETH</div>
                </div>
                <at-input v-model="senderName" placeholder="あなたのお名前" class="input_sender_name"></at-input>
                <at-input v-model="receiverName" placeholder="相手のお名前" class="input_receiver_name"></at-input>
                <at-textarea v-model="message" placeholder="お祝いメッセージ" class="input_message"></at-textarea>
                <at-button type="primary"
                           v-on:click="sendGift"
                           class="send_gift"
                           :disabled="inProgress"
                >
                    祝う！
                </at-button>
            </div>
        </at-card>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import store from '../store'
  import AtInput from "../../node_modules/at-ui/src/components/input/src/input"
  import AtInputNumber from "../../node_modules/at-ui/src/components/input-number/src/input-number"
  import Gift from '../models/Gift'

  export default {
    name: 'GiftForm',
    components: {
      AtInput,
      AtInputNumber
    },
    computed: {
      ...mapGetters([
        'sendingGift',
        'sendGiftSucceeded',
        'inProgress',
        'notificationMessage'
      ])
    },
    watch: {
      inProgress: function (newValue, oldValue) {
        const isProgressEnd = oldValue && !newValue
        if (isProgressEnd) {
          this.$Loading.finish()
        }
      },
      sendGiftSucceeded: function (newValue, oldValue) {
        if (newValue) {
          this.$router.push({ path: 'sent', query: { giftUuid: this.sendingGift.uuid } })
        } else {
          this.$Message.error(this.notificationMessage)
        }
      }
    },
    data () {
      return {
        senderAddress: '',
        receiverAddress: '',
        etherPrice: 0,
        senderName: '',
        receiverName: '',
        message: ''
      }
    },
    methods: {
      sendGift () {
        this.$Loading.start()

        const newGift = new Gift(
          this.generateUuid(),
          this.etherPrice,
          false,
          this.senderAddress,
          this.receiverAddress,
          this.message,
          this.senderName,
          this.receiverName,
          false
        )

        store.dispatch('sendGift', { gift: newGift })
      },
      generateUuid () {
        // https://github.com/GoogleChrome/chrome-platform-analytics/blob/master/src/internal/identifier.js
        // const FORMAT: string = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
        let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("")
        for (let i = 0, len = chars.length; i < len; i++) {
          switch (chars[i]) {
            case "x":
              chars[i] = Math.floor(Math.random() * 16).toString(16)
              break
            case "y":
              chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16)
              break
          }
        }

        return chars.join("")
      }
    }
  }
</script>

<style lang="scss">
    h1, h2 {
        font-weight: normal;
        margin: 16px 0;
    }

    p {
        line-height: 32px;
    }

    .gift_form_root {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .gift_form_description {
        margin-bottom: 32px;

        svg {
            width: 84px;
        }
    }

    @media screen and (min-width: 480px) {
        .eth_gift_card {
            width: 60%;
        }
    }

    .input_ether {
        display: flex;
        flex-direction: row;
        align-items: baseline;
    }

    .input_ether .input_ether_unit {
        margin-left: 16px;
    }

    .input_sender_address, .input_receiver_address, .input_ether, .input_receiver_name, .input_sender_name, .input_message, .send_gift {
        margin-bottom: 16px;
    }

    .gift_form_append_description {
        margin-top: 64px;
    }
</style>



// WEBPACK FOOTER //
// src/components/GiftForm.vue